import router from './router'
import useCommentStore from './store'
import CommentMessages from './localization'

export default {
  router,
  useCommentStore,
  localization: CommentMessages,
}
